import { Button } from "@/components/ui/button"
import type { ButtonProps } from "@/components/ui/button"
import { Loader2 } from "lucide-react"

interface LoadingButtonProps extends ButtonProps {
  loading?: boolean
  loadingText?: string
}

export default function LoadingButton({
  children = "Submit",
  disabled = false,
  loading = false,
  loadingText = "Submitting...",
  ...props
}: LoadingButtonProps) {
  return (
    <Button type="button" disabled={disabled || loading} {...props}>
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {loading ? loadingText : children}
    </Button>
  )
}

